import React, { useEffect } from 'react';

import { useSelector } from 'react-redux';

import { useActions } from 'app/components/Utility/hooks/useAction.hooks';
import { TwisterTypeName } from 'app/constants/twisterType.constants';
import withTranslations from 'app/components/HOGs/withTranslations';
import mapUtils from 'app/libs/Utils/mapUtils';
import RideTwisterSlider from './components/RideTwisterSlider';
import RideTwisterRecalculation from './components/RideTwisterRecalculation';
import RideTwisterCompass from './components/RideTwisterCompass';
import RideTwisterSetPoint from './components/RideTwisterSetPoint';
import { RTService } from '../RideTwister.service';

let ent = null;

const RoundTrip = (props) => {
  const {
    loadingRecalculate,
    compassRotate,
    isSetRotate,
    sliderValue,
    loading,
    setLoading,
    points,
    init,
    // edit,
    // pointsData,
  } = props;
  const { setGPSDataLoadingStatus } = useActions();

  const { getCoefficient, showRT } = RTService;

  const highway = useSelector((store) => store.tourFullData.highway);
  const ferry = useSelector((store) => store.tourFullData.ferry);
  const getAvoidSettings = () => ({
    highway,
    ferry,
  });

  const setRTRoute = (e) => {
    showRT(e);
    if (loading) {
      setLoading(false);
    }
    setGPSDataLoadingStatus({ fetching: false, fetched: true });
  };

  // const setRTRoute = (rtParams) => {
  //   const rtRlCb = () => {
  //     if (loading) {
  //       setLoading(false);
  //     }
  //   };
  //   showRT({ ...rtParams, rtRlCb });
  //   setGPSDataLoadingStatus({ fetching: false, fetched: true });
  // };

  useEffect(() => {
    if (
      (points[0]?.lat && points[0]?.lng && sliderValue > 0 && !init) ||
      (loadingRecalculate === true && !init)
    ) {
      if (ent) {
        clearTimeout(ent);
      }
      ent = setTimeout(() => {
        const options = {
          coefficient: getCoefficient(sliderValue),
          type: TwisterTypeName.RoundTrip,
          israndom: !isSetRotate,
          direction: compassRotate,
          coorditanes: `${points[0].lng},${points[0].lat};${points[0].lng},${points[0].lat}`,
          correction: true,
          overview: 'full',
        };
        mapUtils.twisterServiceOSRM(options, setRTRoute, {
          avoid: getAvoidSettings(),
        });
      }, 500);
      // setRTRoute({
      //   coefficient: getCoefficient(sliderValue),
      //   type: TwisterTypeName.RoundTrip,
      //   israndom: !isSetRotate,
      //   direction: compassRotate,
      //   coorditanes: `${points[0].lng},${points[0].lat};${points[0].lng},${points[0].lat}`,
      //   correction: true,
      //   point: points[0],
      //   isEdit: edit,
      //   oncePointData: pointsData,
      // });
    }
  }, [compassRotate, sliderValue, loadingRecalculate]);

  return (
    <>
      <div className="roundTrip">
        <RideTwisterSlider {...props} />
        <RideTwisterRecalculation {...props} />
      </div>
      <RideTwisterCompass {...props} />
      <RideTwisterSetPoint {...props} />
    </>
  );
};

export default withTranslations(RoundTrip);
